import './bootstrap';
import {initUsersIndex} from "./users";
import {initUsersCreate} from "./users/create";
import {initUsersEdit} from "./users/edit";
import {initUsersDetail} from "./users/detail";
import {initAgentsVoeOrdersIndex} from "../agents/voe-orders";
import {afterComponentLoadBootstrap} from "./bootstrap";
import {initAgentsOrdersProcess} from "../agents/voe-orders/process";
import {initResearchersVoeOrdersIndex} from '../researchers/voe-orders/index';
import {initResearchersVoeOrdersProcess} from "../researchers/voe-orders/process";
import {initViewComponentsExamples} from "../development/view-components/examples";
import {initAdminVoeOrdersIndex} from "./voe-orders";
import {initClientAccountIndex} from "./client-accounts";
import {initClientAccountsCreate} from "./client-accounts/create";
import {initClientAccountsEdit} from "./client-accounts/edit";
import {registerDevelopmentComponents} from "./development/registerDevelopmentComponents";
import {initEmailBaseTemplateIndex} from "./settings/emails/baseEmailTemplateIndex";
import {initEmailVoeTemplateIndex} from "./settings/emails/voeEmailIndex";
import {initPublicVoeOrderRequestIndex} from "../public/voe-order-request";
import {initThirdPartyVoeOrdersIndex} from "../third-party/voe-orders";
import {initThirdPartyOrdersProcess} from "../third-party/voe-orders/process";
import {initVoeAttemptsIndex} from "./settings/voe-attempts/voeAttemptsIndex";
import {initVoeThirdPartyCompanyIndex} from "./third-party-companies";
import {initVoeThirdPartyCompaniesEdit} from "./third-party-companies/edit";
import {initVoeThirdPartyCompanyCreate} from "./third-party-companies/create";
import {initClientVoeAttemptsIndex} from "../client/settings/voe-attempts/voeAttemptsIndex";
import {initClientEmailVoeTemplateIndex} from "../client/settings/emails/voeEmailIndex";
import {initClientEmailBaseTemplateIndex} from "../client/settings/emails/baseEmailTemplateIndex";
import {initCompaniesIndex} from "./companies";
import {initCompaniesCreate} from "./companies/create";
import {initCompaniesEdit} from "./companies/edit";
import {initClientLoginEmailTemplateIndex} from "./settings/emails/clientLoginEmailIndex";
import {initClientAccountHome} from "../client/home";
import {initAdminVoeOrdersDetailIndex} from "./voe-orders/detail";
import {initTwoFactorAuthentication} from "../client/auth/twoFactorAuthentication";
import {initAddressedEmailVoeTemplateIndex} from "./settings/emails/addressedVoeEmailIndex";
import {initClientEmailAddressedVoeTemplateIndex} from "../client/settings/emails/addressedVoeEmailIndex";
import {initAdminArchivedVoeOrdersIndex} from "./voe-orders/archivedOrders";
import {initProfileEdit} from "../profile/edit";
import {initCompaniesDetail} from "./companies/detail";
import {initThirdPartyCompaniesDetail} from "./third-party-companies/detail";
import {initCreateTestVoeOrder} from "../client/sandbox/create-test-voe-order";
import {initManageVoeOrders} from "../client/sandbox/manage-voe-orders";
import {initManageVoeOrder} from "../client/sandbox/manage-voe-order";
import {initBulkOrderImportIndex} from "../client/voe-orders/bulkOrdersImport";
import {initClientVoeOrdersDetailIndex} from "../client/voe-orders/detail";


//TODO: Separate different roles in different files

const adminComponentMap = {
	/**
	 * Users
	 */
	'admin.users.index': {
		action: initUsersIndex,
	},
	'admin.users.create': {
		action: initUsersCreate,
	},
	'admin.users.edit': {
		action: initUsersEdit,
	},
	'admin.users.detail': {
		action: initUsersDetail,
	},

	/**
	 * Companies
	 */
	'admin.companies.index': {
		action: initCompaniesIndex,
	},
	'admin.companies.create': {
		action: initCompaniesCreate,
	},
	'admin.companies.edit': {
		action: initCompaniesEdit,
	},
	'admin.companies.detail': {
		action: initCompaniesDetail,
	},

	/**
	 * Voe Orders
	 */
	'admin.voe-orders.index': {
		action: initAdminVoeOrdersIndex,
	},
	'admin.voe-orders.detail': {
		action: initAdminVoeOrdersDetailIndex,
	},
	'admin.voe-orders.archived-orders': {
		action: initAdminArchivedVoeOrdersIndex,
	},

	/**
	 * Client Accounts
	 */

	'admin.client-accounts.index': {
		action: initClientAccountIndex
	},
	'admin.client-accounts.create': {
		action: initClientAccountsCreate
	},
	'admin.client-accounts.edit': {
		action: initClientAccountsEdit
	},

	/**
	 * Client Account
	 */
	'client.index': {
		action: initClientAccountHome
	},
	'client.auth.two-factor-authentication': {
		action: initTwoFactorAuthentication
	},

	/**
	 * Settings
	 */
	'admins.settings.voe-attempts.index': {
		action: initVoeAttemptsIndex,
	},
	'admins.settings.emails.base-template-index': {
		action: initEmailBaseTemplateIndex
	},
	'admins.settings.emails.voe-template-index': {
		action: initEmailVoeTemplateIndex
	},
	'admins.settings.emails.addressed-voe-template-index': {
		action: initAddressedEmailVoeTemplateIndex,
	},
	'admins.settings.emails.client-login-template-index': {
		action: initClientLoginEmailTemplateIndex
	},

	/**
	 * Third Party Companies
	 */

	'admin.third-party-companies.index': {
		action: initVoeThirdPartyCompanyIndex
	},
	'admin.third-party-companies.create': {
		action: initVoeThirdPartyCompanyCreate
	},
	'admin.third-party-companies.edit': {
		action: initVoeThirdPartyCompaniesEdit
	},
	'admin.third-party-companies.detail': {
		action: initThirdPartyCompaniesDetail
	},
	/**
	 * Profile
	 */

	'admin.profile.edit': {
		action: initProfileEdit
	},

	/**
	 * Development
	 */
	'development.view-components.examples': {
		action: initViewComponentsExamples
	},
};

const researcherComponentMap = {
	'researcher.voe-orders.index': {
		action: initResearchersVoeOrdersIndex,
	},
	'researcher.voe-orders.process': {
		action: initResearchersVoeOrdersProcess,
	}
}

const agentComponentMap = {
	'agent.voe-orders.index': {
		action: initAgentsVoeOrdersIndex
	},
	'agent.voe-orders.process': {
		action: initAgentsOrdersProcess
	}
}

const thirdPartyManagerComponentMap = {
	'third-party.voe-orders.index': {
		action: initThirdPartyVoeOrdersIndex,
	},
	'third-party.voe-orders.process': {
		action: initThirdPartyOrdersProcess,
	},
}

const publicComponentMap = {
	'public.voe-order-request.index': {
		action: initPublicVoeOrderRequestIndex
	},
}

const clientAccountComponentMap = {
	/**
	 * Settings
	 */
	'client.settings.emails.base-template-index': {
		action: initClientEmailBaseTemplateIndex
	},
	'client.settings.voe-attempts.index': {
		action: initClientVoeAttemptsIndex,
	},
	'client.settings.emails.voe-template-index': {
		action: initClientEmailVoeTemplateIndex
	},
	'client.settings.emails.addressed-voe-template-index': {
		action: initClientEmailAddressedVoeTemplateIndex
	},

	/**
	 * Voe orders
	 */
	'client.voe-orders.detail': {
		action: initClientVoeOrdersDetailIndex,
	},
	'client.voe-orders.bulk-order-import': {
		action: initBulkOrderImportIndex,
	},

	/**
	 * Sandbox exclusive routes
	 */
	'client.sandbox.create-test-voe-order': {
		action: initCreateTestVoeOrder,
	},

	'client.sandbox.manage-voe-orders': {
		action: initManageVoeOrders,
	},
	'client.sandbox.manage-voe-order': {
		action: initManageVoeOrder,
	}
}

const componentMap = {
	...adminComponentMap,
	...researcherComponentMap,
	...agentComponentMap,
	...thirdPartyManagerComponentMap,
	...publicComponentMap,
	...clientAccountComponentMap
}

// Register development components
registerDevelopmentComponents(componentMap);

document.addEventListener('DOMContentLoaded', () => {
	// Init components
	if (window.jsComponents) {
		window.jsComponents.forEach(componentKey => {
			if (componentMap[componentKey]) {
				try {
					componentMap[componentKey].action();
				} catch (e) {
					console.log(`Error running component ${componentKey}`);
					console.error(e);
				}
			} else {
				console.error(`"${componentKey}" component not found`);
			}
		})
	}

	afterComponentLoadBootstrap()
})
